// utilitário simples para parse e formatação de datas considerando fusos/locale do navegador
// funções exportadas:
// - parseToDate(dateString) -> Date | null  : tenta interpretar strings ISO, e assume UTC quando timezone ausente
// - formatLocal(dateOrString, locale, options) -> string : formata usando Intl.DateTimeFormat com locale do navegador por padrão
export function parseToDate(dateString) {
  if (!dateString) return null;
  try {
    const s = String(dateString).trim();

    // Se já contém designador de timezone (Z ou +HH:MM / -HH:MM), use diretamente
    if (/[zZ]$/.test(s) || /[+-]\d{2}:?\d{2}$/.test(s)) {
      const d = new Date(s);
      if (!isNaN(d)) return d;
    } else {
      // Se não há designador de timezone, interpretar como naive local (construir Date pelos componentes)
      // Suporta formatos como 'YYYY-MM-DDTHH:mm[:ss[.sss]]'
      const isoNoTZ = s.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?$/);
      if (isoNoTZ) {
        const year = parseInt(isoNoTZ[1], 10);
        const month = parseInt(isoNoTZ[2], 10);
        const day = parseInt(isoNoTZ[3], 10);
        const hour = parseInt(isoNoTZ[4], 10);
        const minute = parseInt(isoNoTZ[5], 10);
        const second = isoNoTZ[6] ? parseInt(isoNoTZ[6], 10) : 0;
        const ms = isoNoTZ[7] ? Math.floor(Number('0.' + isoNoTZ[7]) * 1000) : 0;
        const localConstructed = new Date(year, month - 1, day, hour, minute, second, ms);
        if (!isNaN(localConstructed)) return localConstructed;
      }

      // fallback: tentar interpretar como string direta (alguns engines tratam sem TZ como UTC)
      const local = new Date(s);
      if (!isNaN(local)) return local;

      // se falhar, tentar interpretar como UTC (append 'Z')
      const withZ = s + 'Z';
      const d2 = new Date(withZ);
      if (!isNaN(d2)) return d2;
    }

    // fallback: tentar criar diretamente (última tentativa)
    const d3 = new Date(s);
    if (!isNaN(d3)) return d3;

    return null;
  } catch (e) {
    return null;
  }
}

export function formatLocal(dateOrString, locale = undefined, options = {}) {
  if (!dateOrString) return '--';
  const dt = dateOrString instanceof Date ? dateOrString : parseToDate(dateOrString);
  if (!dt) return '--';
  const loc = locale || (typeof navigator !== 'undefined' && navigator.language) || 'en-US';
  try {
    return new Intl.DateTimeFormat(loc, options).format(dt);
  } catch (e) {
    // fallback simples
    return dt.toLocaleString();
  }
}

const _default = {
  parseToDate,
  formatLocal
};

export default _default;
